import script from "./DimensionInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DimensionInput.vue?vue&type=script&setup=true&lang=ts"

import "./DimensionInput.vue?vue&type=style&index=0&id=3d2d0160&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2d0160"]])

export default __exports__